import { dmxInputFields, dmxVariables, dmxFields } from './dmxGqlChunks';
import { getCreateRouteId, getDetailQueryName, getDetailRouteId, getListRouteId } from './utils';
const DTM_DATA_TYPES = ['TI', 'DI', 'ZPS'];
export const buildRoutesConfig = (tinkerConfig, nonTranslatableResourceStrings) => {
    const layerRoutes = [];
    const pathSegments = window.location.pathname.split('/');
    const appIdIndex = pathSegments.indexOf(tinkerConfig.apps.edges[0].node.nameId);
    const docId = pathSegments[appIdIndex + 1];
    tinkerConfig.mapLayers.edges
        .filter((mapLayer) => mapLayer.node.isInLayerSwitcher)
        .forEach((mapLayerEdge) => {
        const mapLayer = {
            ...mapLayerEdge.node,
            nameId: mapLayerEdge.node.nameId.replaceAll('-', '_'),
        };
        const mapLayerId = mapLayer.nameId;
        const dtmDataType = mapLayer.mapService.schema?.toUpperCase();
        if (!dtmDataType || !DTM_DATA_TYPES.includes(dtmDataType)) {
            console.debug(`[buildLayerSwitcherConfig]: dtmDataType "${dtmDataType}" is not supported.`);
            return;
        }
        nonTranslatableResourceStrings[`Idvfkodsuffix${mapLayerId}Connection`] = mapLayer.title;
        layerRoutes.push({
            id: getListRouteId(mapLayer),
            auth: mapLayer.mapService.isAuth,
            path: `/:idDoc/${mapLayerId}`,
            query: `query query${mapLayerId}
            ($dtmDataType: auto = ${dtmDataType}, $docId: auto = ${docId}) {
                aktualizacniData${mapLayerId}List(filters: {
                  docId: $docId,
                  dtmDataType: $dtmDataType,
                  idvfkodsuffix: "${mapLayerId}"
                }) ${mapLayer.canInsert ? `@create(route: "${getCreateRouteId(mapLayer)}")` : ''} {
                  edges {
                    cursor
                    node
                    @detail(route: "${getDetailRouteId(mapLayer)}")
                    @loadFeature(query: "query${mapLayerId}Feature", pointZoomLevel: 22, replaceHashParams: { idDoc: idDoc })
                    {
                      id @hidden
                      iddtm
                      idprvek
                      urovenumisteni
                      zmena
                      ${dmxFields}
                    }
                  }
                }
              }

              query query${mapLayerId}Feature( $id: ID!) {
                feature: aktualizacniData${mapLayerId}(filters: {
                  docId: ${docId},
                  id: $id,
                  dtmDataType: ${dtmDataType}})
                {
                  id
                  geom: geometrie
                }
              }
            `,
        });
        const queries = [];
        nonTranslatableResourceStrings[`Idvfkodsuffix${mapLayerId}`] =
            `Detail prvku (${mapLayer.title})`;
        queries.push(`
          query ${getDetailQueryName(mapLayer)}($id: ID!, $dtmDataType: auto = ${dtmDataType}) {
            feature: aktualizacniData${mapLayerId}(filters: {
              docId: ${docId},
              id: $id,
              dtmDataType: $dtmDataType })
              {
                ... @group {
                  id @hidden
                  zmena
                  urovenumisteni
                  geom: geometrie @ewkt(projection: "EPSG:5514", layer: "${mapLayerId}", pointZoomLevel: 22)
                  iddtm
                  ${dmxFields}
                }
              }
            }
        `);
        if (mapLayer.canUpdate) {
            queries.push(`
          mutation update(
            $id: auto,
            $dtmDataType: auto = ${dtmDataType}
            $docId: auto = ${docId}
            $zmena: TypZmeny,
            $geom: auto,
            $iddtm: auto @select(query: "iddtmSelectUpdate"),
            $urovenumisteni: auto,
            ${dmxVariables}
          ) @layer(id: "${mapLayerId}")
          {
            updateAktualizacniDataIdvfkodsuffix${mapLayerId}(
              input: {
                id: $id,
                docId: $docId,
                dtmDataType: $dtmDataType,
                common: {
                  geometrie: $geom
                  iddtm: $iddtm
                  idprvek: $id
                  urovenumisteni: $urovenumisteni, # Kdyz se posle zmena v "urovenumisteni", tak se na strane Georealu povede ulozit zmenu geometrie.
                }
                attributes: {
                  ${dmxInputFields}
                }
              }
            ) {
              id
            }
          }

          query iddtmSelectUpdate {
            katalogDtmList(filters: {
              idvfkodsuffix: "${mapLayerId}"
            }) {
              edges {
                node {
                  iddtm @hidden
                  popisdtm
                  #skupina
                  #kategorie
                }
              }
            }
          }
            `);
        }
        if (mapLayer.canDelete) {
            queries.push(`
          mutation delete($id: ID!)
            @redirect(route: "${getListRouteId(mapLayer)}", history: REPLACE)
            @layer(id: "${mapLayerId}")
          {
            deleteAktualizacniData(
              id: $id,
              docId: ${docId},
              dtmDataType: ${dtmDataType}
            ) {
              id
            }
          }`);
        }
        if (queries.length) {
            layerRoutes.push({
                id: getDetailRouteId(mapLayer),
                auth: mapLayer.mapService.isAuth,
                path: `/:idDoc/${mapLayerId}/:id`,
                query: queries.join(' '),
                defaultSize: 'small',
            });
        }
        if (mapLayer.canInsert) {
            const createRouteId = getCreateRouteId(mapLayer);
            if (createRouteId) {
                nonTranslatableResourceStrings[`create${mapLayerId}`] = `Nový prvek (${mapLayer.title})`;
                const createMutation = `
            mutation create${mapLayerId}(
              $urovenumisteni: auto
              $dtmDataType: auto = ${dtmDataType}
              $docId: auto = ${docId}
              $iddtm: auto @select(query: "iddtmSelect")
              $idprvek: auto
              ${dmxVariables}
              $geom: auto @ewkt(projection: "EPSG:5514", geometryType: ${mapLayer.mapService.geometryType}))
              @layer(id: "${mapLayerId}")
              @redirect(route: "${getDetailRouteId(mapLayer)}")
            {
              createAktualizacniDataIdvfkodsuffix${mapLayerId}(
                input: {
                  attributes: {
                    ${dmxInputFields}
                  }
                  common: {
                    geometrie: $geom
                    iddtm: $iddtm
                    idprvek: $idprvek
                    urovenumisteni: $urovenumisteni # Georeal ignoruje hodnotu, ale potrebuje ji
                  }
                  docId: $docId
                  dtmDataType: $dtmDataType
                }
              ) {
                id
                idprvek
              }
            }

            query iddtmSelect {
              katalogDtmList(filters: {
                idvfkodsuffix: "${mapLayerId}"
              }) {
                edges {
                  node {
                    iddtm @hidden
                    popisdtm
                  }
                }
              }
            }
          `;
                layerRoutes.push({
                    id: createRouteId,
                    auth: mapLayer.mapService.isAuth,
                    path: `/:idDoc/${mapLayerId}/novy`,
                    query: createMutation,
                    defaultSize: 'small',
                });
            }
        }
    });
    return layerRoutes;
};
//# sourceMappingURL=buildRoutesConfig.js.map